export const requiredValidateEmail = (value: string): string | undefined => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!value) {
    return "Email is required.";
  }
  if (!emailRegex.test(value)) {
    return "Invalid email address.";
  }
  return undefined;
};

export const requiredValidatePhoneNumber = (value: string): string | undefined => {
  if (!value) return "Phone number is required.";
  const digits = value.replace(/\D/g, "");
  if (digits.length < 10 || digits.length > 15) {
    return "Phone number must be 10-15 digits.";
  }
  return undefined;
};

export const validateEmail = (value: string): string | undefined => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (value && !emailRegex.test(value)) {
    return "Invalid email address.";
  }
  return undefined;
};

export const validatePhoneNumber = (value: string): string | undefined => {
  if (!value) return undefined;
  // Strip formatting: (647) 667-1647 → 6476671647
  const digits = value.replace(/\D/g, "");
  if (digits.length > 0 && (digits.length < 10 || digits.length > 15)) {
    return "Phone number must be 10-15 digits.";
  }
  return undefined;
};
